import { Divider, Typography } from "antd"

const About = () => {
    return (
        <div>
            <Typography.Title>What is L & R?</Typography.Title>
            <Typography.Text>
                R is short for Ryan. But L is a little different. When we first matched, Ella did not use her full name on Hinge.
                Instead, she shortened her name to "Ell". When pronounced out loud, it sounds like the letter L.
                Ever since then, we have been referring to each other as L and R. Our Christmas stockings say L and R.
                Even our shared document where we log our dates also refers to us as L and R.
            </Typography.Text>

            <Divider />

            <Typography.Title>Our Story</Typography.Title>
            <Typography.Text>
                We matched on Hinge on September 1, 2024. Our first date was September 7, 2024. And we got engaged 1 year later on September 8, 2025.
                During a vacation in Seattle, WA for our 1 year anniversary, we went on a ferry to Friday Harbor.
                In the middle on the water on the ferry, R found a private place on the boat with no one around.
                At 12:41pm, R asked L to marry him. R was nervous, so he didn't say what he was planning.
                He started off by saying "You're very kind". L was surprised, so the best she could say was "yeah".
                For the rest of the ride to the island, we sat there and stared
                at the ring. At one point, R said to L "You said yes, right?". It felt so surreal. But also
                incredibly special. We felt so grown up. It was all a blur.
            </Typography.Text>

            <Divider />

            <Typography.Title>Our Trips</Typography.Title>
            <Typography.Text>
                We love going on road trips and adventures together. We've done so much in just a singe year, 
                doing something almost every other month. Here's some highlights of what we've done.
            </Typography.Text>

            <ul>
                <li><Typography.Text>January 2025 - Seaside, OR. Our first trip together! Birthday trip for L/Valentine's day.</Typography.Text></li>
                <li><Typography.Text>March 2025 - Seattle, WA. Our first time in Seattle. This became our favorite place to go.</Typography.Text></li>
                <li><Typography.Text>May 2025 - Bend, OR. Birthday trip for R.</Typography.Text></li>
                <li><Typography.Text>July 2025 - Florence, OR. Camping in a motorhome.</Typography.Text></li>
                <li><Typography.Text>August 2025 - Crater Lake, OR. We drove to and back in just one day. 10 hours of driving and only spent a few hours there.</Typography.Text></li>
                <li><Typography.Text>September 2025 - Seattle, WA. This is where R proposed to L.</Typography.Text></li>
            </ul>

            <Divider />

            <Typography.Title>Our Song</Typography.Title>
            <iframe title="Song" data-testid="embed-iframe" src="https://open.spotify.com/embed/track/6qqrTXSdwiJaq8SO0X2lSe?utm_source=generator" width="100%" height="352" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" style={{ borderRadius: '16px' }} />
        </div>
    );
};

export default About;